import api from 'helpers/api';
import { toast } from 'sonner';

class ProductService {
  async getProducts() {
    try {
      const response = await api.get('/api/v2/products');
      sessionStorage.setItem('products', JSON.stringify(response.data));
      return response.data;
    } catch (error) {
      toast.error('Something went wrong', { description: 'Error getting products' });
      return [];
    }
  }
}

export default new ProductService();
